<template>
  <span class="text-left">
    <ed-button button-class="btn btn-actionbar"
               @click="showModal(showTransferFunds)"
               :ids="ids"
               :disabled="disabled"
               v-tooltip="tooltip">
      Transfer Funds
    </ed-button>
    <ed-modal
      title="Transfer EvedPay Card Account Funds"
      :show="showTransferFunds"
      @close='showModal(showTransferFunds)'
      validation
      @validate='transferFunds'
      primary-button="TRANSFER FUNDS"
    >
      <div slot="body" class='transfer-funds-overlay'>
        <p class="small">Move funds between accounts.</p>
        <label>Transfer From</label>
        <ed-select :options='divisions' @open="getUserDivisions" label='Division' name='divisions' slot="additionalInfo_1" @input="(option) => {
                    this.selectOptionFrom.Division = option.Division
                    this.selectOptionFrom.Available = option.Available
                    this.selectOptionFrom.AccountId = option.Id
                  }">

          <template slot='option'
                    slot-scope='props'>
            <div class="dropdown-option">
              <span class="division-name">{{ props.option.Division }}</span>
              <span class="available-amount-wrapper">
                Available: <span>{{ props.option.Available.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} USD</span>
              </span>
            </div>
          </template>
        </ed-select>

        <label>Transfer To</label>
        <ed-select :options="divisions.filter(filterOptions)" @open="getUserDivisions" label="Division" name="divisions" slot="additionalInfo_1" @input="setSelectOptionTo">

          <template slot='option'
                    slot-scope='props'>
            <div class="dropdown-option">
              <span class="division-name">{{ props.option.Division }}</span>
              <span class="available-amount-wrapper">
                Available: <span>{{ props.option.Available.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} USD</span>
              </span>
            </div>
          </template>
        </ed-select>
        <div class="form-group">
          <ed-input field-label="Amount"
                    hide-optional
                    @input="(o) => { initialAmount = +o; this.initialAmountError = false; }"
                    type="money"
                    amount
                    v-model='initialAmount'
                    placeholder="Amount"
                    :error='initialAmountError'
                    helptip-header=''
                    class="full-width">
            <div slot="message" v-if="initialAmountError">
              {{ errorMessage }}:
              <strong>
                <v-money>{{selectOptionFrom.Available}}</v-money>
              </strong>
            </div>
          </ed-input>
        </div>
      </div>
    </ed-modal>
  </span>
</template>

<script>
  import User from '@/core/user'
  export default {
    props: {
      division: {},
      ids: null,
      disabled: false,
      tooltip: ''
    },

    data() {
      return {
        divisions: [],
        divisionName: '',
        selectOption: {},
        selectedValue: {},
        closeObj: {},
        showTransferFunds: false,
        initialAmount: '',
        initialAmountError: false,
        errorMessage: 'The amount cannot be greater than the current balance'
      }
    },

    created() {
      this.getDivisionNameToSingularWithLowerCase()
      this.selectOptionFrom = {}
      this.selectOptionTo = {}
    },

    methods: {
      async getUserDivisions() {
        this.divisions = []
        try {
          const response = await this.api.post(this.api.$.evedpaycard.accounts)
          if (response && response.data && response.data.Data) {
            this.divisions = response.data.Data
          }
        } catch (error) {
          console.warn(error)
        }
      },

      filterOptions(option) {
        return this.selectOptionFrom.AccountId !== option.Id
      },

      setSelectOptionTo(option) {
        this.selectOptionTo.Division = option.Division
        this.selectOptionTo.Available = option.Available
        this.selectOptionTo.AccountId = option.Id
      },

      getDivisionNameToSingularWithLowerCase() {
        var divisionName = User.get().settings['DivisionName']
        this.divisionName = divisionName[divisionName.length - 1] === 's' ? divisionName.toLowerCase().slice(0, -1) : divisionName
      },

      async transferFunds() {
        const command = {
          SourceAccountId: this.selectOptionFrom.AccountId,
          DestinationAccountId: this.selectOptionTo.AccountId,
          Amount: this.initialAmount
        }

        if (this.initialAmount <= 0 || this.initialAmount > this.selectOptionFrom.Available) {
          this.initialAmountError = true
          return
        }

        try {
          const response = await this.api.post('/evedpaycards/accounts/transfer-funds', command)
          if (response.status === 200) {
            this.$emit('success')
            this.showTransferFunds = false
            this.initialAmountError = false
          }
        } catch (error) {
          //
        }
      },

      showModal(showTransferFunds) {
        this.showTransferFunds = !showTransferFunds
        if (!showTransferFunds) {
          this.resetModal()
        }
      },

      resetModal() {
        this.selectOptionFrom = {}
        this.selectOptionTo = {}
        this.initialAmount = ''
        this.initialAmountError = false
      }
    }
  }
</script>

<style lang='scss' scoped>
  .transfer-funds-overlay {
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }

  .available-amount-wrapper {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-accounts/TransferFunds.vue